import _ from 'underscore';
import Backbone from 'backbone';
import * as baseTracking from '../../home24-shared/core/base-tracking';

export default Backbone.View.extend(_.extend({
    /**
     * destroy backbone view, unbind all events etc.
     */
    destroy: function () {
        this.undelegateEvents();
        this.stopListening();
    }
}, baseTracking));



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/core/baseTrackingView.js
 **/